import { Link } from "react-router";

export const BorderedIconTile = ({ tiles }) => {
	return (
		<div className="grid grid-cols-2 md:grid-cols-5 gap-4">
			{tiles.map(({ title, imageUrl, alt, url }, index) => {
				if (url) {
					return (
						<Link to={url} key={`${title}-${index}`}>
							<TileContent title={title} imageUrl={imageUrl} alt={alt} />
						</Link>
					);
				}
				return <TileContent title={title} imageUrl={imageUrl} alt={alt} key={`${title}-${index}`} />;
			})}
		</div>
	);
};

const TileContent = ({ title, imageUrl, alt }) => {
	return (
		<div className="flex flex-col justify-center items-center border-[1px] border-solid border-is2-gray-150 m-2 rounded-sm h-[150px] py-10 px-4">
			<img src={imageUrl} alt={alt} className="h-[48px] m-0" loading="lazy" />
			<h6 className="pt-2 text-center text-is2-gray-800">{title}</h6>
		</div>
	);
};
